import { attr } from '@ember-data/model';
import Super from './document';

export default class UnauthenticatedInsuranceCard extends Super {
  @attr() file;
  @attr() clientId;
}
